import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";

export const MoreForChildrenSection = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleRedirection = () => {
    const path =
      currentLanguage === "en" ? "/enroll" : `/${currentLanguage}/enroll`;
    history.push(path);
  };

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: "#FFF8F1",
        textAlign: "center",
        py: 8,
        my: 8,
        mx: { xs: 2, md: "15%" },
      }}
    >
      <Typography
        variant="h4"
        fontWeight={700}
        color={theme.palette.primary.light}
        gutterBottom
      >
        {t("ProgramPage.MoreForChildrenSection.title")}
      </Typography>

      <Typography
        variant="body1"
        color="text.primary"
        maxWidth={800}
        mx="auto"
        mb={2}
      >
        {t("ProgramPage.MoreForChildrenSection.text1")}
      </Typography>

      <Typography
        variant="body1"
        color="text.primary"
        maxWidth={800}
        mx="auto"
        mb={6}
      >
        {t("ProgramPage.MoreForChildrenSection.text2")}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={10} md={5}>
          <Box
            sx={{
              borderRadius: 4,
              boxShadow: "4px 4px 6px 0px rgba(0, 0, 0, 0.5)",
              p: 3,
              position: "relative",
              zIndex: 1,
              minHeight: 300,
            }}
          >
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {t("ProgramPage.MoreForChildrenSection.titleCard1")}
            </Typography>
            <Typography variant="body1" color="text.primary">
              {t("ProgramPage.MoreForChildrenSection.textCard1")}
            </Typography>
            <Box
              component="img"
              src="/birds/small-red.webp"
              alt="Bird left"
              sx={{
                position: "absolute",
                left: -50,
                bottom: isMobile ? -42 : -33,
                width: 100,
                zIndex: 2,
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={10} md={5}>
          <Box
            sx={{
              borderRadius: 4,
              boxShadow: "4px 4px 6px 0px rgba(0, 0, 0, 0.5)",
              p: 3,
              position: "relative",
              zIndex: 1,
              minHeight: 300,
            }}
          >
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {t("ProgramPage.MoreForChildrenSection.titleCard2")}
            </Typography>
            <Typography variant="body1" color="text.primary">
              {t("ProgramPage.MoreForChildrenSection.textCard2")}
            </Typography>
            <Box
              component="img"
              src="/birds/small-blue.webp"
              alt="Bird right"
              sx={{
                position: "absolute",
                right: -50,
                bottom: isMobile ? -50 : -33,
                width: 100,
                zIndex: 2,
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <OrangeHighlightButton onClick={handleRedirection} sx={{ mt: 4 }}>
        {t("ProgramPage.MoreForChildrenSection.buttonText")}
      </OrangeHighlightButton>
    </Box>
  );
};
